import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { TooltipPosition } from './tooltip-position';
import { TooltipTheme } from './tooltip-theme';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  standalone: false,
})
export class TooltipComponent {
  @Input() position: TooltipPosition = TooltipPosition.ABOVE;
  @Input() theme: TooltipTheme = TooltipTheme.LIGHT;
  @Input() tooltip = '';
  @Input() shortcut = '';
  @Input() left = 0;
  @Input() top = 0;
  @Input() visible = false;

  @ViewChild('tooltipBox', { static: true })
  private readonly tooltipBox!: ElementRef<HTMLElement>;

  constructor() {}

  showInTopLayer(): void {
    const element = this.tooltipBox.nativeElement;

    if (typeof element.showPopover !== 'function') {
      return;
    }

    element.setAttribute('popover', 'manual');
    element.showPopover();
  }
}
